import request from '../utils/request';

// All browser requests stay on Admin; only Admin talks to user/message over gRPC.
const call = async (method, path, data) => {
    const result = await request[method](path, data);
    if (result === false || result == null) {
        const error = new Error('请求未完成，请检查网络、登录状态或操作权限。');
        error.reported = true;
        throw error;
    }
    return result;
};
export const getPushMetadata = async () => {
    const metadata = await call('get', '/push/metadata');
    const types = metadata.types || [];
    return {
        ...metadata,
        types: types.some((type) => type.code === 'CUSTOM') ? types : [...types, { code: 'CUSTOM', name: '自定义', description: '自行添加推送参数' }],
        platforms: (metadata.platforms || []).filter((p) => ['android', 'ios', 'web', 'unknown'].includes(p)),
    };
};
export const listPushCampaigns = (params) => call('get', '/push/campaign/list', params);
export const getPushCampaign = (id) => call('get', '/push/campaign/get', { id });
export const savePushCampaign = (params) => call('post', '/push/campaign/save', params);
export const translatePushCampaign = (params) => call('post', '/push/campaign/translate', params);
export const estimatePushAudience = (platforms) => call('post', '/push/audience/estimate', { platforms });
export const publishPushCampaign = (params) => call('post', '/push/campaign/publish', params);
export const cancelPushCampaign = (params) => call('post', '/push/campaign/cancel', params);
export const retryPushCampaign = (params) => call('post', '/push/campaign/retry', params);
export const duplicatePushCampaign = (params) => call('post', '/push/campaign/duplicate', params);
export const batchDeletePushCampaigns = (campaigns) => call('post', '/push/campaign/batch-delete', { campaigns });
export const searchPushRecipients = async (keyword) => {
    const result = await call('post', '/push/test/recipient', { keyword });
    return result.matches || [];
};
export const resolvePushRecipient = async (params) => {
    const recipient = await call('post', '/push/test/recipient', params);
    return { ...recipient, devices: (recipient.devices || []).filter((d) => (
        (d.channel === 'app' && ['android', 'ios', 'unknown'].includes(d.platform))
        || (d.channel === 'web' && d.platform === 'web')
    )) };
};
export const sendPushTest = (params) => call('post', '/push/campaign/test', params);
export const getPushDeliveries = (params) => call('get', '/push/campaign/deliveries', params);
